import axios from "axios";
import initializeAxios from "../util/Axios";

class ContentServices {
  constructor() {
    initializeAxios();
  }

  async getCategories({ searchTerm, isActive, pageIndex, pageSize }) {
    const response = await axios.get("/api/categories", {
      params: {
        searchTerm,
        isActive,
        pageIndex,
        pageSize
      }
    });

    return response.data;
  }

  async addCategory({
    slug,
    categoryStatus,
    parentCategory,
    title,
    keywords,
    description,
    shortDescription,
    content,
    categoryName,
    isFeatured,
    banners,
    image
  }) {
    const response = await axios.post("/api/category/add", {
      slug,
      categoryStatus,
      parentCategory,
      title,
      keywords,
      description,
      shortDescription,
      content,
      categoryName,
      isFeatured,
      banners,
      image
    });

    return response;
  }

  async editCategory({
    categoryId,
    slug,
    categoryStatus,
    parentCategory,
    title,
    keywords,
    description,
    shortDescription,
    content,
    categoryName,
    isFeatured,
    banners,
    image
  }) {
    const response = await axios.put("/api/category/update", {
      categoryId,
      slug,
      categoryStatus,
      parentCategory,
      title,
      keywords,
      description,
      shortDescription,
      content,
      categoryName,
      isFeatured,
      banners,
      image
    });

    return response;
  }

  async deleteCategory(categoryId, isActive) {
    const response = await axios.put("/api/category/delete", {
      categoryId,
      isActive
    });

    return response.data;
  }

  async removeBanner(bannerId) {
    const response = await axios.get("/api/banner/delete", {
      params: {
        bannerId,
      },
    });
    return response;
  }
  
  async getCategoryDetails(id) {
    const response = await axios.get("/api/category/details", {
      params: {
        categoryId: id
      }
    });

    return response;
  }

  async getCategoryList() {
    const response = await axios.get("/api/categorieslist");
    return response.data;
  }

  async uploadToS3(data) {
    const formData = new FormData();
    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.post("/api/util/uploadimage", formData);
    return response.data;
  }

}

export default new ContentServices();
